import { ClientTelerikReportPage } from "../components/ClientTelerikReportPage";
import { CLIENTS_ALL_ROLES } from "../../SharedModule/utils/constants";

export const ClientHubspotIntegrationLogReportPage = () => (
  <ClientTelerikReportPage
    documentTitle="The Hub - HubSpot Integration Log Report"
    reportTitle="HubSpot Integration Log"
    reportName="HubSpotIntegrationLogs.trdp"
    allowedRoles={CLIENTS_ALL_ROLES}
    parametersAreaVisible={true}
    includeImportDate={true}
  />
);
